module.exports = __webpack_public_path__ + "img/info.c8c2265e.svg";